import type { ReactNode } from "react";

// A press on a control nested in the SelectorBar PressButton otherwise reaches
// its onPress, which opens the version dropdown on pointerdown (with a click
// fallback); ClickButton children can't guard their own pointerdown, so wrap
// them here to stop both.
export function StopBarPress({ children }: { children: ReactNode }) {
  return (
    <span
      style={{ display: "contents" }}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </span>
  );
}
